import http from "../api/apiClient";

/**
 * @typedef {Object} SiblingMetrics
 * @property {number} householdsWithSiblings
 * @property {number} totalSiblingPairs
 * @property {number} totalChildrenWithSiblings
 * @property {number} averageChildrenPerSiblingFamily
 * @property {number} largestSiblingGroup
 */

/** Haal de volledige sibling-metrics op zoals de backend ze teruggeeft. */
export const fetchSiblingMetrics = async () => {
  try {
    const { data } = await http.get("/reports/sibling-statistics");

    if (data && typeof data === "object" && !Array.isArray(data)) {
      return {
        householdsWithSiblings: Number(data.householdsWithSiblings ?? 0),
        totalSiblingPairs: Number(data.totalSiblingPairs ?? 0),
        totalChildrenWithSiblings: Number(data.totalChildrenWithSiblings ?? 0),
        averageChildrenPerSiblingFamily: Number(data.averageChildrenPerSiblingFamily ?? 0),
        largestSiblingGroup: Number(data.largestSiblingGroup ?? 0),
      };
    }

    if (typeof data === "number") {
      return {
        householdsWithSiblings: data > 0 ? 1 : 0,
        totalSiblingPairs: Math.max(0, Math.floor(data / 2)),
        totalChildrenWithSiblings: data,
        averageChildrenPerSiblingFamily: data > 0 ? data : 0,
        largestSiblingGroup: data,
      };
    }

    if (Array.isArray(data)) {
      const count = data.length;
      return {
        householdsWithSiblings: count > 0 ? 1 : 0,
        totalSiblingPairs: Math.max(0, Math.floor(count / 2)),
        totalChildrenWithSiblings: count,
        averageChildrenPerSiblingFamily: count > 0 ? count : 0,
        largestSiblingGroup: count,
      };
    }

    return {
      householdsWithSiblings: 0,
      totalSiblingPairs: 0,
      totalChildrenWithSiblings: 0,
      averageChildrenPerSiblingFamily: 0,
      largestSiblingGroup: 0,
    };
  } catch (error) {
    if (error?.response?.status === 403) {
      return {
        householdsWithSiblings: 0,
        totalSiblingPairs: 0,
        totalChildrenWithSiblings: 0,
        averageChildrenPerSiblingFamily: 0,
        largestSiblingGroup: 0,
      };
    }

    console.error("Error fetching sibling metrics:", error?.response?.data || error?.message);
    throw error;
  }
};

/**
 * Backward-compatible wrapper die één getal teruggeeft voor een tegel.
 * Default: aantal gezinnen met siblings (householdsWithSiblings).
 * Wil je “Children with siblings”? Zet de returnregel om naar:
 *   return m.totalChildrenWithSiblings;
 */
export const fetchSiblingStats = async () => {
  const metrics = await fetchSiblingMetrics();
  return metrics.householdsWithSiblings; // ← eventueel vervangen door metrics.totalChildrenWithSiblings
};
